export default{
  ADD_COUNT({commit},num){
    setTimeout(() => {
      commit('ADD',num)
    }, 2000);
  }
}